import { H2, Text } from '@ui';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import styles from './CompanyDetails.module.css';
import { AnnualProfitQuestion } from './questions/AnnualProfitQuestion';
import { CompanyNameQuestion } from './questions/CompanyNameQuestion';
import { CompanyTypeQuestion } from './questions/CompanyTypeQuestion';
import { IndustryQuestion } from './questions/IndustryQuestion';
import { TradingFromQuestion } from './questions/TradingFromQuestion';
import { TradingNameQuestion } from './questions/TradingNameQuestion';
import { TurnoverQuestion } from './questions/TurnoverQuestion';
import { WebsiteQuestion } from './questions/WebsiteQuestion';
import { getCountry } from '../../../iwIntlProvider/CountryProvider';
import type { RootState } from '../../../iwProvider/configureStore';

type Props = { companyType: { value: string; label: string } };

const CompanyDetailsView = ({ companyType }: Props) => {
    const isSoleTrader = companyType.value === 'sole_trader';

    return (
        <div className="space-y-xl">
            <div>
                <H2>
                    <FormattedMessage
                        id="_.your_company.company_details.title"
                        defaultMessage="Details"
                    />
                </H2>
                <Text className="mt-xs">
                    <FormattedMessage
                        id="_.your_company.company_details.subtitle"
                        defaultMessage="Edit my company details"
                    />
                </Text>
            </div>
            <form
                className={styles.detailsFormWrapper}
                autoComplete="off"
                onSubmit={(e) => e.preventDefault()}
            >
                <div className={styles.detailsFormQuestions}>
                    {isSoleTrader ? (
                        <>
                            <TradingNameQuestion />
                            <CompanyTypeQuestion />
                            <IndustryQuestion />
                            <WebsiteQuestion />
                            <TurnoverQuestion />
                            {getCountry() === 'UK' && <AnnualProfitQuestion />}
                            <TradingFromQuestion />
                        </>
                    ) : (
                        <>
                            <CompanyNameQuestion />
                            <CompanyTypeQuestion />
                            <WebsiteQuestion />
                            <TurnoverQuestion />
                            <TradingFromQuestion />
                        </>
                    )}
                </div>
            </form>
        </div>
    );
};

export const CompanyDetails = connect((state: RootState) => ({
    companyType: state.profile.companyType
}))(CompanyDetailsView);
